import React from 'react';
import styled from 'styled-components';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { findIconDefinition, IconName, library } from '@fortawesome/fontawesome-svg-core';
import { CartaXIcon } from '../../assets/Icons';

library.add(fas);

// Constants
const COLOR_BY_THEME = {
  dark: 'white',
  light: 'black',
  'light-secondary': 'rgb(180,180,180)',
};

// Fragments
const SiteKitIconWrapper = styled.div`
  font-size: 14px;
  padding: 0;
  pointer-events: none;
  display: inline-flex;
  align-items: center;
`;

// Exports
interface SiteKitIconProps {
  icon: string;
  theme?: 'light' | 'light-secondary' | 'dark';
}
const SiteKitIcon = ({ icon, theme = 'dark' }: SiteKitIconProps) => {
  const iconDefinition = findIconDefinition({ prefix: 'fas', iconName: icon as IconName });
  const color = COLOR_BY_THEME[theme] || COLOR_BY_THEME.light;

  return (
    <SiteKitIconWrapper>
      {icon === 'xing' && <CartaXIcon />}
      {icon !== 'xing' && <FontAwesomeIcon color={color} icon={iconDefinition} />}
    </SiteKitIconWrapper>
  );
};

SiteKitIcon.displayName = 'SiteKit.Icon';

export { SiteKitIcon, SiteKitIconProps };
